<template>
    <div class="g-recaptcha" :data-sitekey="siteKey"></div>
</template>
<script>
    export default {
        data() {
            return {
                siteKey: null
            }
        },
        mounted() {
            this.siteKey = document.head.querySelector('meta[name="re-captcha"]').content;
        }
    }
</script>


// WEBPACK FOOTER //
// Captcha.vue?465b083a